import {materialCloudServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = materialCloudServicesPath + '/admin/supplier-materials'

export default class AdminSupplierMaterialCloudService {

    static async getAllCurrentWholeByMaterialId(materialId) {
        return axios.get(restUrl + '/material/' + materialId + '/current', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCurrentByMaterialIdMinStripe(materialId) {
        return axios.get(restUrl + '/material/' + materialId + '/current-min-stripe', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllCurrentByMaterialIdFixedStripe(materialId) {
        return axios.get(restUrl + '/material/' + materialId + '/current-fixed-stripe', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllWholeByMaterialId(materialId) {
        return axios.get(restUrl + '/material/' + materialId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByMaterialIdMinStripe(materialId) {
        return axios.get(restUrl + '/material/' + materialId + '/min-stripe', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllByMaterialIdFixedStripe(materialId) {
        return axios.get(restUrl + '/material/' + materialId + '/fixed-stripe', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(data) {
        return await axios.patch(restUrl + '/' + data.id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async sendToArchive(id) {
        return await axios.patch(restUrl + '/' + id+"/send-to-archive", {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createByMaterialOrganizationOption(data, materialId, supplierId, currencyId, price) {
        return await axios.post(restUrl + '/material' + "?materialId="
            + materialId + "&supplierId=" + supplierId + "&currencyId=" + currencyId + "&price=" + price, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}